module.exports = __webpack_public_path__ + "static/media/bg.643eb0f7.svg";